import React from 'react';
import { 
  Row, 
  Col, 
  Pagination, 
  Form,
  Button
} from 'react-bootstrap';

const BannerPagination = ({ 
  currentPage, 
  totalPages, 
  totalItems, 
  itemsPerPage,
  onPageChange, 
  loading 
}) => {
  if (totalPages <= 1) {
    return (
      <Row className="align-items-center">
        <Col>
          <div className="text-muted small">
            <i className="las la-info-circle me-1" />
            Total: {totalItems} banner{totalItems !== 1 ? 's' : ''}
          </div>
        </Col>
      </Row>
    );
  }

  const generatePaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;
    
    // Calcular range de páginas visíveis
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    // Ajustar se necessário
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Primeira página
    if (startPage > 1) {
      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 1}
          onClick={() => !loading && onPageChange(1)}
          disabled={loading}
        >
          1
        </Pagination.Item>
      );
      
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    // Páginas do range
    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <Pagination.Item
          key={page}
          active={currentPage === page}
          onClick={() => !loading && onPageChange(page)}
          disabled={loading}
        >
          {page}
        </Pagination.Item>
      );
    }

    // Última página
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
      
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => !loading && onPageChange(totalPages)}
          disabled={loading}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  const handleJumpToPage = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const page = parseInt(formData.get('jumpPage'));
    
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
    
    e.target.reset();
  };

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <Row className="align-items-center">
      <Col md={6} className="mb-3 mb-md-0">
        <div className="pagination-info text-muted small">
          <i className="las la-info-circle me-1" />
          Mostrando {startItem}-{endItem} de {totalItems} banner{totalItems !== 1 ? 's' : ''}
        </div>
      </Col>

      <Col md={6}>
        <div className="d-flex justify-content-md-end align-items-center gap-3">
          {/* Jump to Page */}
          {totalPages > 10 && (
            <Form onSubmit={handleJumpToPage} className="d-flex align-items-center gap-2">
              <span className="small text-muted">Ir para:</span>
              <Form.Control
                type="number"
                name="jumpPage"
                min="1"
                max={totalPages}
                placeholder={currentPage}
                style={{ width: '70px' }}
                size="sm"
                disabled={loading}
              />
              <Button
                type="submit"
                variant="outline-secondary"
                size="sm"
                disabled={loading}
              >
                <i className="las la-arrow-right" />
              </Button>
            </Form>
          )}

          {/* Pagination */}
          <Pagination className="mb-0" size="sm">
            <Pagination.First
              onClick={() => !loading && onPageChange(1)}
              disabled={currentPage === 1 || loading}
            />
            <Pagination.Prev
              onClick={() => !loading && onPageChange(currentPage - 1)}
              disabled={currentPage === 1 || loading}
            />
            
            {generatePaginationItems()}
            
            <Pagination.Next
              onClick={() => !loading && onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages || loading}
            />
            <Pagination.Last
              onClick={() => !loading && onPageChange(totalPages)}
              disabled={currentPage === totalPages || loading}
            />
          </Pagination>
        </div>
      </Col>
    </Row>
  );
};

export default BannerPagination;